import React, { useState } from 'react';

import { DialogTitle, getLocalDate } from '@bestelleck/shared';
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';

export const TimezoneAlert: React.FC = () => {
    const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const localSeconds = Math.floor(new Date().getTime() / 1000);
    const serverSeconds = Math.floor(getLocalDate().getTime() / 1000);

    const [open, setOpen] = useState(localSeconds !== serverSeconds);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog onClose={handleClose} open={open}>
            <DialogTitle id="Title" onClose={handleClose} colorScheme="primary">
                Andere Zeitzone
            </DialogTitle>
            <DialogContent style={{ marginTop: 20 }}>
                Dein Gerät hat eine andere Zeitzone eingestellt ({localTimezone}). Wir haben die hier angezeigten Zeiten
                angepasst, um die korrekte lokale Uhrzeit zu verwenden. Wir empfehlen dennoch, die eingestellte Zeitzone
                anzupassen.
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Ok</Button>
            </DialogActions>
        </Dialog>
    );
};
